import * as React from 'react'

import { TableProvider } from '@/modules/drivers/context/TableContext'
import BlocksGroup from '../tabs/blocks/views/Group'
import Single from '../tabs/blocks/views/Single'
import { RouteComponentProps } from '@/app/navigation/withRouter'

interface RouteParams {
  companyId: string
  vehicleId?: string
}

export const VehicleBlocksPage: React.FC<RouteComponentProps<RouteParams>> = ({
  match,
}) => {
  const { companyId, vehicleId } = match.params

  return (
    <section className="tw-flex tw-h-full tw-flex-col">
      {vehicleId ? (
        <Single companyId={companyId} vehicleId={vehicleId} />
      ) : (
        <TableProvider>
          <BlocksGroup companyId={companyId} />
        </TableProvider>
      )}
    </section>
  )
}
